var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: _vm.titulo } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      "item-text": "nombre",
                      items: _vm.lista_clientename,
                      label: _vm.formFields.cliente_id_new.label,
                      "item-value": "rut",
                      "prepend-icon": "home_repair_service"
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_flota()
                      }
                    },
                    model: {
                      value: _vm.formFields.cliente_id_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente_id_new, "value", $$v)
                      },
                      expression: "formFields.cliente_id_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.cliente_id_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.cliente_id_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente_id_new, "value", $$v)
                      },
                      expression: "formFields.cliente_id_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.cod_flota_new.label,
                      required: "",
                      "item-text": "nombre",
                      "item-value": "id",
                      items: _vm.lista_flotaname,
                      "prepend-icon": "integration_instructions",
                      color: "primary"
                    },
                    model: {
                      value: _vm.formFields.cod_flota_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cod_flota_new, "value", $$v)
                      },
                      expression: "formFields.cod_flota_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.cod_flota_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.cod_flota_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cod_flota_new, "value", $$v)
                      },
                      expression: "formFields.cod_flota_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          rules: {
                            required: true,
                            max: 200,
                            regex: /^(?:[a-zA-Z]{4}\d{2}|[a-zA-Z]{2}\d{4})$/i
                          }
                        },
                        expression:
                          "{\n          rules: {\n            required: true,\n            max: 200,\n            regex: /^(?:[a-zA-Z]{4}\\d{2}|[a-zA-Z]{2}\\d{4})$/i,\n          },\n        }"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.patente_vehiculo_new.label,
                      required: "",
                      "prepend-icon": "integration_instructions",
                      color: "primary",
                      "error-messages": _vm.errors.collect("patente"),
                      "data-vv-name": "patente",
                      id: "your-text-field-id"
                    },
                    on: { input: _vm.handleInput },
                    model: {
                      value: _vm.formFields.patente_vehiculo_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.patente_vehiculo_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.patente_vehiculo_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.patente_vehiculo_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.patente_vehiculo_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.patente_vehiculo_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.patente_vehiculo_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }